module.exports = __webpack_public_path__ + "static/media/integral_list_item_03.2353c5a7.png";